import styled from 'styled-components'

// Sits on top of the waveform/thumbnails (which carry no z-index) but below the
// selection border + resize handles (z-index 3). Non-interactive so it never
// blocks clicks/resize. preserveAspectRatio="none" lets the 0..100 viewBox map
// directly onto the item's pixel box; the diagonal stays crisp via
// vector-effect="non-scaling-stroke".
export const Svg = styled.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
`
